<template>
  <FormRow class="designation" inline>
    <FormSelect field="applications.0.campaign">
      <option selected="selected" value="Orthodox Union (All OU Programs)">
        Orthodox Union (All OU Programs)
      </option>
      <option value="OU Advocacy">OU Advocacy</option>
      <option value="JLIC Campus Learning">JLIC Campus Learning</option>
      <option value="NCSY Youth Outreach">NCSY Youth Outreach</option>
      <option value="NCSY Alumni">NCSY Alumni</option>
      <option value="NCSY Summer Programs">NCSY Summer Programs</option>
      <option value="OU Community Engagement">OU Community Engagement</option>
      <option value="OU Israel">OU Israel</option>
      <option value="OU Passover Food Campaign">OU Passover Food Campaign</option>
      <option value="Yachad/NJCD">Yachad/NJCD</option>
    </FormSelect>
    <ErrorLabel field="applications.0.campaign" style="text-align: right" />
  </FormRow>
</template>
<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue } = usePaymentForm();

    return {
      getValue,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>
